import { SVGProps } from 'react';

const ListEnd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 12H3m13-6H3m7 12H3M21 6v10a2 2 0 0 1-2 2h-5m2 2-2-2 2-2"
    />
  </svg>
);
export default ListEnd;
